module.exports = __webpack_public_path__ + "static/media/logoToLoja.e0815a6d.png";